import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const Banner = React.forwardRef(function Banner2({ tone = "neutral", title, icon, action, className, children, ...rest }, ref) {
  const hasTitle = title != null && title !== false;
  return /* @__PURE__ */ jsxs("div", { ref, className: cx("ev-banner", className), "data-tone": tone, ...rest, children: [
    icon != null && icon !== false ? /* @__PURE__ */ jsx("span", { className: "ev-banner__icon", "aria-hidden": "true", children: icon }) : null,
    /* @__PURE__ */ jsxs("div", { className: "ev-banner__body", children: [
      hasTitle ? /* @__PURE__ */ jsx("strong", { className: "ev-banner__title", children: title }) : null,
      children != null && children !== false ? /* @__PURE__ */ jsx("div", { className: "ev-banner__text", children }) : null
    ] }),
    action != null && action !== false ? /* @__PURE__ */ jsx("div", { className: "ev-banner__action", children: action }) : null
  ] });
});
export {
  Banner
};
//# sourceMappingURL=Banner.js.map
